export enum PrimaryCareTableHeaderLabels {
  DATE_OF_SERVICE = "Date of Service",
  TASK = "Task",
  PATIENT_DETAILS = "Patient Details",
  DATE_OF_BIRTH = "Date of Birth",
  AUTH_TYPE = "Auth Type",
  KEY = "Key",
  KEY_SOURCE = "Key Tag",
  STATUS = "Status",
  ACTIONS = "Actions",
  RESPONSE_STATUS = "Response Status",
  SUBMIT = "Submit",
  ROUTE = "Route",
  ASSIGNED_TO = "Assigned To",
  UPDATE = "Update",
}

export enum PrimaryCareTableColumnKeys {
  DATE_OF_SERVICE = "dateOfService",
  TASK = "task",
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_BIRTH = "dateOfBirth",
  AUTH_TYPE = "authType",
  KEY = "key",
  KEY_SOURCE = "keySource",
  STATUS = "status",
  ACTIONS = "actions",
  RESPONSE_STATUS = "responseStatus",
  SUBMIT = "submit",
  ROUTE = "route",
  ASSIGNED_TO = "assignedTo",
  UPDATE = "update",
}
